import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject
} from "@denishussar/html5-game-engine";
import {AnimationContents} from "../AnimationContents";
import {GameLogic} from "../../Logic/GameLogic";
import {GameTopMenuController} from "./GameTopMenuController";
import {GameModel} from "../../Models/GameModel";

export class GamePanelController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _fullScreenManager: FullScreenManager) {
        super("GamePanelController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAMES_SCREEN_JSON,
            libraryName: "top_panel_container",
            childControllers: {
                GameTopMenuController: {
                    instanceName: "top_menu",
                    view: GameTopMenuController,
                    model: this.$model
                }
            }
        };
    }

    protected onInitialize(): void {
        this.setTextByQuery("coin_panel.coins_collected", this.$model.scoreA.toString());
    }

    protected onResize(width: number, height: number, scale: number): void {

        this.x = -width / scale / 2.5;
        this.y = -height / scale / 2.5;

        this.setPosXByQuery("coin_panel", -width / scale / 2);
    }

}

